import React from 'react';
import { Modal, Box, Button } from '@goodrx/matisse';
import { useToggledState } from 'app/hooks';
import { useSynapse } from 'app/lib/synaptik';
import { LegalCodes } from '@goodrx/heydoctor-core';
import * as Analytics from 'app/lib/analytics';
import { HmaCheckbox } from 'app/components/legal/HmaCheckbox';
import { HmaModalCopy } from 'app/components/legal/HmaInfoModal/HmaInfoModal';

export const HmaConsentModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  attributionSource: Analytics.ConsentSource;
}> = ({ isOpen, onClose, attributionSource }) => {
  const [consented, toggledConsented] = useToggledState(false);
  const [agreeToLegals, agreeingToLegals] = useSynapse(({ user }: any) => [
    user.agreeToLegals,
    user.state.agreeingToLegals,
  ]);

  const handleConsent = async () => {
    await agreeToLegals([LegalCodes.HIPAAMarketingAuthorization]);
    Analytics.onHmaConsent({ source: attributionSource });
    onClose();
  };

  return (
    <Modal open={isOpen} title="HIPAA Marketing Authorization" minWidth={320} maxWidth={400} onClose={onClose}>
      <Modal.Body>
        <HmaModalCopy />

        <Box my={3}>
          <HmaCheckbox value={consented} onChange={toggledConsented} />
        </Box>

        <Button block onClick={handleConsent} disabled={agreeingToLegals || !consented} loading={agreeingToLegals}>
          See Prices
        </Button>
      </Modal.Body>
    </Modal>
  );
};
